import Util from "@/helper/Utility.js";
import ModalMaster from "@/components/Modal/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";

export default {
    data: function () {
        return {
            modalFactory: new ModalFactory(),
            modalController: null,
        };
    },
    components: {
        ModalMaster,
    },
    created: function () {
        this.initialGenericModal();

        if (Util.isFunction(this.onSetupModalCompleted)) {
            this.onSetupModalCompleted();
        }
    },
    methods: {
        initialGenericModal: function () {
            this.modalController = this.modalFactory.getModalController();
            this.alertModal = this.modalFactory.getAlertModal();
            this.confirmModal = this.modalFactory.getConfirmModal();
            this.loadingModal = this.modalFactory.getLoadingModal();
        },
        inititalPdpaModal: function () {
            this.pdpaModal = this.modalFactory.getPdpaModal();
            this.cancelTermsAndPrivacyModal = this.modalFactory.getCancelTermsAndPrivacyModal();
        },
        initialChangeMobileNumberModal: function () {
            this.changeMobileNumberModal = this.modalFactory.getChangeMobileNumberModal();
        },
        initialRedeemModal: function () {
            this.confirmRedeemModal = this.modalFactory.getConfirmRedeemModal();
            this.drawDeliveryModal = this.modalFactory.getDrawDeliveryModal();
            this.serialModal = this.modalFactory.getSerialModal();
            this.shippingAddressModal = this.modalFactory.getShippingAddressModal();
            this.shareModal = this.modalFactory.getShareModal();
        },
        initialHistoryModal: function () {
            this.serialModal = this.modalFactory.getSerialModal();
        },
        initialAddressModal: function() {
            this.addAddressModal = this.modalFactory.getAddAddressModal();
            this.editAddressModal = this.modalFactory.getEditAddressModal();
            this.listAddressModal = this.modalFactory.getListAddressModal();
        },
        initialTaxAddressModal: function() {
            this.addTaxAddressModal = this.modalFactory.getAddTaxAddressModal();
            this.editTaxAddressModal = this.modalFactory.getEditTaxAddressModal();
            this.listTaxAddressModal = this.modalFactory.getListTaxAddressModal();
        },
        initialFlashSaleModal: function () {
            this.flashSaleModal = this.modalFactory.getFlashSaleModal();
        },
        initialbadgeAlertModal: function () {
            this.badgeAlertModal = this.modalFactory.getBadgeAlertModal();
        },
        initialSurpriseBoxModal: function () {
            this.confirmSurpriseModal = this.modalFactory.getConfirmSurpriseModal();
            this.alertConditionModal = this.modalFactory.getAlertConditionModal();
            this.verifyCodeModal = this.modalFactory.getVerifyCodeModal();
        },
        initialFGFModal: function () {
            this.fgfModal = this.modalFactory.getFGFModal();
            this.sharefgfModal = this.modalFactory.getShareFGFModal();
        },
        initialPromocode: function () {
            this.promocodeModal = this.modalFactory.getPromocodeModal();
            this.promocodeSuccessModal = this.modalFactory.getPromocodeSuccessModal();
        }
    }
}
